/**
 * Hides an HTML element by setting its display style and aria-hidden attribute.
 * @param {HTMLElement | null} el - The element to hide.
 * @param {string} [display='none'] - The display style to set.
 */
export const hideElement = (
    el: HTMLElement | null,
    display: string = 'none',
): void => {
    if (!el) {
        return;
    }
    el.style.display = display;
    el.setAttribute('aria-hidden', 'true');
};
